import { axiosClient } from "@/shared/api/axios-client";
import type { ConfiguracionDocumental } from "@/features/admin-gestion-documental/configuracion-documental";

/**
 * Gestión Documental (fase 2) · catálogo CREABLE de categorías de documento. Las de sistema
 * (`esSistema`) las usa el código: no se borran, desactivan ni cambian de código; las que registra
 * el servidor (`esDelServidor` · factura del CFDI / Invoice) tienen extensiones fijas.
 */
export interface CategoriaDocumentoDto {
  id: string;
  codigo: string;
  nombre: string;
  descripcion: string | null;
  extensiones: string[];
  /** Tope propio · null = el límite global (Documentos:TamanoMaximoMB). */
  tamanoMaximoBytes: number | null;
  esSistema: boolean;
  esDelServidor: boolean;
  activa: boolean;
  orden: number;
  /** Al subir un documento hay que clasificarlo con un tipo (P31). */
  requiereTipo: boolean;
  configuracion: ConfiguracionDocumental;
}

export interface EditarCategoriaInput {
  nombre: string;
  descripcion: string | null;
  extensiones: string[];
  tamanoMaximoBytes: number | null;
  orden: number;
  requiereTipo: boolean;
  configuracion: ConfiguracionDocumental;
}

export interface CrearCategoriaInput extends EditarCategoriaInput {
  codigo: string;
}

const BASE = "/api/admin/categorias-documento";

export interface ListarCategoriasParams {
  busqueda?: string;
  soloActivas?: boolean;
  page?: number;
  pageSize?: number;
}

/** Envelope paginado del backend + conteos del catálogo completo para el header. */
export interface PaginaCategoriasDocumento {
  items: CategoriaDocumentoDto[];
  total: number;
  page: number;
  pageSize: number;
  totalCatalogo: number;
  totalActivas: number;
  totalSistema: number;
}

export async function listarCategoriasDocumento(
  params: ListarCategoriasParams = {},
): Promise<PaginaCategoriasDocumento> {
  const { data } = await axiosClient.get<PaginaCategoriasDocumento>(BASE, {
    params,
  });
  return data;
}

export async function crearCategoria(
  input: CrearCategoriaInput,
): Promise<CategoriaDocumentoDto> {
  const { data } = await axiosClient.post<CategoriaDocumentoDto>(BASE, input);
  return data;
}

export async function editarCategoria(
  id: string,
  input: EditarCategoriaInput,
): Promise<CategoriaDocumentoDto> {
  const { data } = await axiosClient.patch<CategoriaDocumentoDto>(
    `${BASE}/${id}`,
    input,
  );
  return data;
}

export async function cambiarEstadoCategoria(
  id: string,
  activa: boolean,
): Promise<CategoriaDocumentoDto> {
  const { data } = await axiosClient.post<CategoriaDocumentoDto>(
    `${BASE}/${id}/estado`,
    { activa },
  );
  return data;
}

export async function eliminarCategoria(id: string): Promise<void> {
  await axiosClient.delete(`${BASE}/${id}`);
}
